// src/amplifyConfig.js
import { Amplify } from "aws-amplify";

const amplifyConfig = {
  Auth: {
    Cognito: {
      region: "us-east-1",
      userPoolId: "us-east-1_7Aep6F3em",
      userPoolClientId: "19ais0tbkrurus8mkf4b8nqvlk",
      loginMechanisms: ["EMAIL"], // or ["USERNAME"]
      signUpAttributes: ["email"], // required attributes
      authenticationFlowType: "USER_PASSWORD_AUTH"
    }
  }
};

Amplify.configure(amplifyConfig);

export default amplifyConfig;
